import { WizardContainerComponentProps } from '../wizard-container.model';
import { EditScreenController } from './edit-screen.controller';

const EditScreen = (props: WizardContainerComponentProps): JSX.Element => {
  return <EditScreenController {...props} />;
};

export default EditScreen;
